export default {
  state: {
    isLogin: false,    // 是否已经登录
    unRead: 0,
    ActNum: 0 // 活动主页的消息数量
  },
  mutations: {
    set_isLogin (state, val) {
      state.isLogin = val
    },
    set_unRead (state, val) {
      console.log('set_unRead', val)
      state.unRead = val
    },
    setActNum (state, val) {
      state.ActNum = val
    },
    setActNum_1 (state, val) {
      state.ActNum = state.ActNum - 1
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/login.js